<script>
    import TagDisplay from '../Tag/TagDisplay.svelte';
    import Thumbnail from '../common/Media/Thumbnail.svelte';
    import {sgettext} from '../../i18n.js';

    export let tool = {};
</script>

<style>
    .icon {
        width: 64px;
        margin-right: 30px;
        padding: 15px;
    }

    .icon img {
        width: 100%;
    }

    .table-icon {
        max-width: 128px;
    }

    .table-icon img {
        width: 100%;
    }

    .other-info {
        color: #858585;
        font-size: 14px;
    }

    section header {
        padding: 10px 15px;
        background-color: #dee2e6;
    }

    table th {
        background-color: #dee2e6;
        border-bottom: 0px;
    }

    section header h6 {
        margin: 0;
    }

    label h6 {
        margin-bottom: 0em;
    }

    .tool-tags span {
        font-size: 12px;
    }
</style>

<section>
    <div class="card">
        <div class="card-header">
          <h6 class="mb-0">{sgettext('$$TOOL_DETAILS$$')}</h6>
        </div>
        <div class="card-body d-flex">
            <div class="icon col-3">
                {#if tool.image}
                    <Thumbnail
                        url={tool.image.url}
                        media={tool.image.url}
                        type={tool.image.type.toLowerCase().includes('video') ? 'VIDEO' : 'IMAGE'}/>
                {/if}
            </div>
            <div class="detail col">
                <div class="row mb-3">
                    <div class="col">
                        <label><h6>{sgettext('$$TOOL_NAME$$')}</h6></label>
                        <div class="tool-name">{tool.name}</div>
                    </div>
                    <div class="col">
                        <label><h6>{sgettext('$$TOOL_TAGS$$')}</h6></label>
                        <div class="tool-tags"><TagDisplay tags={tool.tags} /></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label><h6>{sgettext('$$TOOL_DESCRIPTION$$')}</h6></label>
                        <div class="">{tool.description}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {#if tool.specifications.length > 0}
    <div class="tool-detail mt-3">
        <table class="table border">
            <thead>
                <tr>
                    <th>{sgettext('$$SPECIFICATION_NAME$$')}</th>
                    <th>{sgettext('$$TOOL_SPEC_IMAGE$$')}</th>
                    <th>{sgettext('$$TOOL_SPEC_TAGS$$')}</th>
                </tr>
            </thead>
            <tbody>
                {#each tool.specifications as specification}
                    {#if !specification.deleted}
                        <tr>
                            <td>{specification.description}</td>
                            <td>
                                <div class="table-icon">
                                    {#if specification.image}
                                        <Thumbnail
                                            url={specification.image.url}
                                            media={specification.image.url}
                                            type={specification.image.type.toLowerCase().includes('video') ? 'VIDEO' : 'IMAGE'}/>
                                    {/if}
                                </div>
                            </td>
                            <td class="text-left">
                                <div class="tool-tags"><TagDisplay tags={specification.tags} /></div>
                            </td>
                        </tr>
                    {/if}
                {/each}
            </tbody>
        </table>
    </div>
    {/if}
</section>

